module.exports = "<payment-method-page></payment-method-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/paymentMethodView.html
// module id = 2199
// module chunks = 0